import type { FC } from 'react';
import styles from '../styles/page-actions.module.scss';
import ActionButton from './action-button';

const PageActions: FC<{
    actionTitle: string;
    backTitle?: string;
    actionButtonDisabled?: boolean;
    actionButtonLoading?: boolean;
    onOk: () => void;
    onCancel: () => void;
}> = ({
    actionTitle,
    backTitle = '戻る',
    actionButtonDisabled = false,
    actionButtonLoading = false,
    onOk,
    onCancel,
}) => {
    return (
        <div className={styles.pageActions}>
            <ActionButton
                title={actionTitle}
                disabled={actionButtonDisabled}
                loading={actionButtonLoading}
                onClick={onOk}
            />
            <ActionButton
                title={backTitle}
                primary={false}
                loading={actionButtonLoading}
                onClick={onCancel}
            />
        </div>
    );
};

export default PageActions;
